import React from 'react';

const CookieUserData = React.createContext();

export default CookieUserData;
